export default "__VITE_ASSET__96b0002e__"